import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BasicModalComponent } from './basic-modal/basic-modal.component';
import { ConfermaDialogComponent, ConfermaDialogOptions } from './conferma-dialog/conferma-dialog.component';
import { ConfirmModalComponent, ConfirmModalOptions } from './confirm-modal/confirm-modal.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { CodeDescriptionError } from './models';
import { SuccessModalComponent } from './success-modal/success-modal.component';

@Injectable({
    providedIn: 'root',
})
export class NotifyUserService {
    constructor(private matSnackBar: MatSnackBar, private dialog: MatDialog) {}

    showError(codeDescriptionError: CodeDescriptionError) {
        console.warn('codeDescriptionError', codeDescriptionError);

        const data = {
            erroreHtml: codeDescriptionError.description.message,
            messaggi: codeDescriptionError.internalErrors,
        };
        if (codeDescriptionError.showModal) {
            this.showErrorModal(data);
        }
    }

    showSimpleError(message: string) {
        return this.matSnackBar.open(message, null, { duration: 3000 });
    }

    showErrorModal(data: { erroreHtml: string; messaggi: string[]; titolo?: string }) {
        return this.dialog.open<ErrorModalComponent>(ErrorModalComponent, {
            maxWidth: '40%',
            maxHeight: '80%',
            panelClass: 'toolbar-dialog',
            data: data,
        });
    }

    showBasicModal(data: { title: string; message: string }) {
        return this.dialog.open<BasicModalComponent, { title: string; message: string }>(BasicModalComponent, {
            data,
            maxWidth: '40%',
            maxHeight: '80%',
            panelClass: 'toolbar-dialog',
        });
    }

    showSuccessModal(titleDialog: string, message: string, cta?: string) {
        const modalOptions = new MessageSuccessOptions(titleDialog, message, cta);

        return this.dialog.open<SuccessModalComponent, MessageSuccessOptions>(SuccessModalComponent, {
            data: modalOptions,
            width: 'auto',
            maxWidth: '25%',
            height: 'auto',
            panelClass: 'toolbar-dialog',
        });
    }

    showTemplateRefModal(templateRef: TemplateRef<any>, width: string = null) {
        return this.dialog.open<TemplateRef<any>>(templateRef, { panelClass: 'toolbar-dialog', width });
    }

    showSuccess(message: string, duration = 3000) {
        return this.matSnackBar.open(message, 'OK', { duration, panelClass: ['green-bg', 'success-snackbar'] });
    }

    showWarn(message: string, duration = 3000, panelClass = ['red-bg', 'error-snackbar']) {
        var customConfig = { duration, panelClass };
        return this.matSnackBar.open(message, 'Attenzione', customConfig);
    }

    showInformation(message: string, duration = 3000) {
        return this.matSnackBar.open(message, null, { duration });
    }

    confirm(message: string, buttonLabel: string = 'Conferma') {
        const confirmDialogRef = this.dialog.open<ConfermaDialogComponent, ConfermaDialogOptions, boolean>(ConfermaDialogComponent, {
            disableClose: false,
            data: {
                message: message,
                buttonLabel: buttonLabel,
            },
        });
        return confirmDialogRef.afterClosed();
    }

    showConfirmModal(
        titleDialog: string,
        htmlMessage: string,
        buttonLabel: string = 'Sì',
        buttonLabelAnnulla: string = 'No',
        showCtaAnnulla = true,
        withPassword = false,
        disableClose = false
    ) {
        return this.dialog.open<ConfirmModalComponent, ConfirmModalOptions, boolean>(ConfirmModalComponent, {
            disableClose: disableClose,
            data: {
                titolo: titleDialog,
                message: htmlMessage,
                cta: buttonLabel,
                buttonLabelAnnulla: buttonLabelAnnulla,
                showCtaAnnulla: showCtaAnnulla,
                withPassword,
            },
            width: 'auto',
            panelClass: 'toolbar-dialog',
        });
    }
}

export class MessageSuccessOptions {
    constructor(public titleDialog: string, public message: string, public cta: string) {}
}
